module.exports = __webpack_public_path__ + "img/box-2.16054ff3.gif";